import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  stopManyProductionInstances,
  stopManyProductionInstancesFailure,
  stopManyProductionInstancesSuccess
} from './production-instance.stop-many.actions';
import {ProductionInstancesService} from '../../../services/api/production-instances/production-instances.service';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';
import {loadVmixServers, manyProductionInstancesStatusChanged} from '../actions/vmix-servers.actions';


@Injectable()
export class ProductionInstanceStopManyEffects {

  // noinspection JSUnusedGlobalSymbols
  stopManyProductionInstances$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyProductionInstances),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<ProductionInstance>[] = ids
            .map((id: UUID): Observable<ProductionInstance> =>
              this.service.stop(id)
            );

          return forkJoin(requests)
            .pipe(
              map(() => stopManyProductionInstancesSuccess({ids: ids})),
              catchError((error: any) => of(stopManyProductionInstancesFailure({error: error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  stopManyProductionInstancesSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyProductionInstancesSuccess),
        tap(() =>
          this.snackBar.open('Production Instances successfully stopped', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) =>
          manyProductionInstancesStatusChanged({ids: data.ids, status: 'stopping'})
        )
      );
  });

  // noinspection JSUnusedGlobalSymbols
  stopManyProductionInstancesFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyProductionInstancesFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to stop production instances: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadVmixServers())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: ProductionInstancesService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
